// extracted by mini-css-extract-plugin
module.exports = {"consultations":"Consultations_consultations__rRSjo"};